"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var owa_analytics_1 = require("owa-analytics");
var owa_options_store_2 = require("owa-options-store");
var OPTION_NAVIGATION_KEY = 'OptionDirectNavigation';
exports.default = satcheljs_1.orchestratorAction('showFullOptions', function showFullOptions(category, subcategory, option) {
    if (option) {
        // The option value is only set if the user navigated to a specific option,
        // rather than just opening the full options from the link at the bottom of the flex pane.
        // We should log the option chosen, as well as the current search term
        owa_analytics_1.logUsage(OPTION_NAVIGATION_KEY, [option, owa_options_store_1.getStore().searchTerm]);
    }
    owa_options_store_2.initializeFullOptions(category, subcategory, option);
});
//# sourceMappingURL=showFullOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/showFullOptions.js
// module id = 3772
// module chunks = 2